import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import styles from "./app.module.css";
import Header from "./components/header/Header";
import { useEffect, useState } from "react";
import BattleAndBuild from "./components/battleAndBuild/BattleAndBuild";
import AboutUs from "./components/aboutUs/AboutUs";
import { HeaderMobileMenuIsOpen } from "./context/HeaderMobileMenuIsOpen";
function App() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/homepage");
    }
  }, []);
  const [headerMobileMenuIsOpen, setHeaderMobileMenuIsOpen] = useState(false);
  useEffect(() => {
    if (headerMobileMenuIsOpen) {
      document.body.style = "overflow:hidden";
    } else {
      document.body.style = "overflow:auto";
    }
  }, [headerMobileMenuIsOpen]);
  return (
    <HeaderMobileMenuIsOpen.Provider
      value={{ headerMobileMenuIsOpen, setHeaderMobileMenuIsOpen }}
    >
      <div className={styles.container}>
        <Header />
        <Routes>
          <Route path="/homepage" element={<Home />} />
          <Route path="/battle&build" element={<BattleAndBuild />} />
          <Route path="/aboutUs" element={<AboutUs />} />
        </Routes>
        <Footer />
      </div>
    </HeaderMobileMenuIsOpen.Provider>
  );
}

export default App;
